<template>
    <div  ref="formRef" class="p-contact__form p-contact__form--finish">
        <h2>{{ $t('TEXT_CONTACT_US_COMPLETE_1') }}</h2>
        <p>{{ $t('TEXT_CONTACT_US_COMPLETE_2') }}</p>
        <p>{{ $t('TEXT_CONTACT_US_COMPLETE_3') }}</p>
    </div>

    <div class="p-contact__btn p-contact__btn--finish">
        <div class="c-btn c-btn--contact-back"><button @click="router.push({ name: 'top.page' })">{{ $t("LABEL_GO_TO_MYPAGE") }}</button></div>
    </div>
</template>
<script setup>
import { onMounted, ref } from "vue";
import router from "@/router";

const formRef = ref();
onMounted(async () => {
    formRef.value.scrollIntoView({ behavior: "smooth", block: "center" });
});
</script>